// Unlike portal.eu, casino.eu uses axios (portal to be upgraded later)
import axios from '@/axios.config';

// Feed
export function apiGetFeed () {
  return axios.get('/api/feed');
}
// export function apiGetFeed (gameType) {
//   return axios.get('/api/feed', {
//     params: {
//       include: 'casino.recentUpdatesCount',
//       game_types: [
//         {
//           slug: gameType
//         }
//       ],
//       types: [
//         {
//           type: 'offer'
//         },
//         {
//           type: 'article'
//         }
//       ]
//     }
//   });
// }

export function apiGetFilteredFeed (request) {
  return axios.get('/api/feed', {
    params: {
      game_types: request
    }
  });
}

// News
export function apiGetNews (args) {
  return axios.get('/api/news', {
    params: {
      ...args
    }
  });
}

export function apiGetMostPopularNews (args) {
  return axios.get('/api/most-popular-news', {
    params: {
      ...args
    }
  });
}

export function apiGetNewsArticle (slug) {
  return axios.get(`/api/news/${ slug }`);
}

export function apiPutIncrementNewsRead (slug) {
  return axios.put(`/api/news/${ slug }/increment-read-by-number`);
}

// Casinos
export function apiGetCasinos (args) {
  return axios.get('/api/casinos', {
    params: {
      include: 'stats',
      order: 'order',
      ...args
    }
  });
}

export function apiGetCasinoTypes (args) {
  return axios.get('/api/casino-types', {
    params: {
      ...args
    }
  });
}

export function apiGetCasinosSummary (args) {
  return axios.get('/api/casinos-summary', {
    params: {
      ...args
    }
  });
}

export function apiGetCasinosViews () {
  return axios.get('/api/casinos-views/');
}

// Casino
export function apiGetCasino (slug, args = {}) {
  return axios.get(`/api/casinos/${ slug }`, {
    params: {
      ...args
    }
  });
}

export function apiGetCasinoFeed (slug, args, token = null) {
  return axios.get(`/api/casino/feed/${ slug }`, {
    cancelToken: token,
    params: {
      is_active: true,
      is_coming_soon: false,
      ...args
    }
  });
}

// Insights
export function apiGetInsights (args) {
  return axios.get('/api/insights', {
    params: {
      ...args
    }
  });
}

// Offers
export function apiGetOffers (args) {
  return axios.get('/api/offers', {
    params: {
      ...args
    }
  });

  // return axios.get('/api/feed', { 
  //   params: {
  //     // include: 'casino.recentUpdatesCount',
  //     // limit: 16,
  //     game_types: [
  //       {
  //         slug: gameType
  //       },
  //     ],
  //     types: [
  //       {
  //         type: 'offer'
  //       }
  //     ]
  //   }
  // });
}

export function apiGetOffer (slug) {
  return axios.get(`/api/offers/${ slug }`);
}

export function apiGetPreviousWeekOfferStats (slug) {
  return axios.get(`/api/offers-previous-week-stats`);
}

export function apiGetSuggestedOffers (args) {
  return axios.get('/api/suggested-offers', {
    params: {
      ...args
    }
  });
}

export function apiGetTrendingOffer (args) {
  return axios.get('/api/trending-offers', {
    params: {
      ...args
    }
  });
}

export function apiPutIncrementOfferRead (slug) {
  return axios.put(`/api/offers/${slug}/increment-read-by-number`);
}

// User
export function apiPutUserInitialised () {
  return axios.put('/api/me/login-initialised');
}

export function apiGetFavouriteCasinosSummary () {
  return axios.get('/api/me/favourite-casinos-summary');
}

export function apiGetFavouriteCasinos () {
  return axios.get('/api/me/favourite-casinos', {
    params: {
      include: 'stats'
    }
  });
}

export function apiPutFavouriteCasino (slug) {
  return axios.put('/api/me/favourite-casinos', {
    casino_slug: slug
  });
}

export function apiDeleteFavouriteCasino (slug) {
  return axios.delete(`/api/me/favourite-casinos/${ slug }`);
}

export function apiGetRecentlyPlayedGames () {
  return axios.get('/api/me/recently-played-games');
}

export function apiGetFavouriteGamesSummary () {
  return axios.get('/api/me/favourite-games-summary');
}

export function apiGetFavouriteGames () {
  return axios.get('/api/me/favourite-games', {
    params: {
      include: 'stats,suggestedCasinos.casinoGameStats'
    }
  });
}

export function apiPutFavouriteGame (slug) {
  return axios.put('/api/me/favourite-games', {
    game_slug: slug
  });
}

export function apiDeleteFavouriteGame (slug) {
  return axios.delete(`/api/me/favourite-games/${ slug }`);
}

export function apiGetFavouriteOffersSummary () {
  return axios.get('/api/me/favourite-offers-summary');
}

export function apiGetFavouriteOffers () {
  return axios.get('/api/me/favourite-offers', {
    params: {
      include: 'casino'
    }
  });
}

export function apiPutFavouriteOffer (slug) {
  return axios.put('/api/me/favourite-offers', {
    offer_slug: slug
  });
}

export function apiDeleteFavouriteOffer (slug) {
  return axios.delete(`/api/me/favourite-offers/${ slug }`);
}

// Games
export function apiGetGames (args, token = null) {
  var axiosParams = {
    is_active: true,
    is_coming_soon: false,
    game_types: [
      {
        slug: 'slots'
      },
      {
        slug: 'videoslots'
      },
    ],
    ...args
  };

  if (Laravel.supplierSlug.length) {
    axiosParams.suppliers = [
      {
        slug: Laravel.supplierSlug
      }
    ];
  }

  return axios.get('/api/games', {
    cancelToken: token,
    params: axiosParams
  });
}

export function apiGetGameOfTheWeek () {
  return axios.get('/api/game-of-the-week', {
    params: {
      game_types: [
        {
          slug: 'slots'
        },
        {
          slug: 'videoslots'
        },
      ],
      include: 'game.stats'
    }
  });
}

export function apiGetGameThemes () {
  return axios.get('/api/game-themes', {
    params: {
      order: 'name:asc',
      include: 'themeStats'
    }
  });
}

export function apiGetGameCategories () {
  return axios.get('/api/game-categories');
}

export function apiGetSearchGames (term, token, args) {
  var axiosParams = {
    search: term,
    is_active: true,
    is_coming_soon: false,
    game_types: [
      {
        slug: 'slots'
      },
      {
        slug: 'videoslots'
      },
    ],
    ...args
  };

  if (Laravel.supplierSlug.length) {
    axiosParams.suppliers = [
      {
        slug: Laravel.supplierSlug
      }
    ];
  }

  return axios.get('/api/games', {
    cancelToken: token,
    params: axiosParams
  });
}

export function apiGetPrefilteredGames () {
  return axios.get('/api/game-carousels', {
    params: {
      include: 'game.stats,game.suggestedCasinos.casinoGameStats'
    }
  });
}

export function apiGetGamesTotalCount () {
  return axios.get('/api/games-total-count');
}

export function apiGetGamesComingSoon (args) {
  return axios.get('/api/games-coming-soon', {
    params: {
      ...args
    }
  });
}

// Game
export function apiGetGame (slug, args = {}) {
  return axios.get('/api/games/' + slug, {
    params: {
      ...args
    }
  });
}

export function apiPutIncrementGamePlay (slug) {
  return axios.put(`/api/games/${ slug }/increment-number-of-plays`);
}

export function apiPostGamePlayed (slug) {
  return axios.post('/api/me/recently-played-games', {
    game_slug: slug
  });
}

// Suppliers
export function apiGetSuppliers (args = {}) {
  return axios.get(`/api/suppliers`, {
    params: {
      ...args
    }
  });
}

export function apiGetSuppliersSummary (args = {}) {
  return axios.get(`/api/suppliers-summary`, {
    params: {
      ...args
    }
  });
}

// Supplier
export function apiGetSupplier (slug, args = {}) {
  return axios.get(`/api/suppliers/${ slug }`, {
    params: {
      ...args
    }
  });
}

export function apiGetFavouriteSuppliers () {
  return axios.get('/api/me/favourite-suppliers', {
    params: {
      include: 'stats'
    }
  });
}

export function apiGetFavouriteSuppliersSummary () {
  return axios.get('/api/me/favourite-suppliers-summary');
}

export function apiPutFavouriteSupplier (slug) {
  return axios.put('/api/me/favourite-suppliers', {
    supplier_slug: slug
  });
}

export function apiDeleteFavouriteSupplier (slug) {
  return axios.delete(`/api/me/favourite-suppliers/${ slug }`);
}

// Global
export function apiGetMore (url) {
  return axios.get(url);
}

export function apiGetGameTypes () {
  return axios.get('/api/game-types');
}


// Countries
export function apiGetCountries (args) {
  return axios.get('/api/countries', {
    params: {
      ...args
    }
  });
}

// Cities
export function apiGetCities (args) {
  return axios.get('/api/cities', {
    params: {
      ...args
    }
  });
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/api.js